import { FormHelperText, makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    fontWeight: 500,
    color: theme.palette.neutral.dark3,
    margin: '4px 14px 0px 14px'
  }
}))


export const CharCountHelpText = props => {

  const classes = useStyles();

  if (!props.max) {
    return '';
  }

  return (
    <FormHelperText 
      className={classes.root} 
      variant="filled" 
      error={props.length > props.max}
      id={`${props.id}-char-count`}
    >
      {props.length} of {props.max} Character Limit
    </FormHelperText>
  ) 
}